
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 28.575a2.9 2.9 0 01-2.3-1.225l-1.873-2.5a.554.554 0 00-.212-.1H10a15.7 15.7 0 01-3.5-.318A6.2 6.2 0 013.716 23.1C2.2 21.773 1.5 19.6 1.5 16.25V10c0-5.561 2.939-8.5 8.5-8.5h7.5a1 1 0 011 1 1 1 0 01-1 1H10a6.737 6.737 0 00-4.918 1.582A6.737 6.737 0 003.5 10v6.25c0 2.729.487 4.426 1.533 5.341.929.809 2.414 1.159 4.967 1.159h.625a2.4 2.4 0 011.8.9l1.872 2.5a.916.916 0 00.7.425.916.916 0 00.7-.425l1.875-2.5v-.005a2.271 2.271 0 011.8-.895H20a6.737 6.737 0 004.918-1.582A6.737 6.737 0 0026.5 16.25V12.5a1 1 0 012 0v3.75c0 5.561-2.939 8.5-8.5 8.5h-.625a.267.267 0 00-.2.1l-1.875 2.5a2.9 2.9 0 01-2.3 1.225z","fill":"#bac1cc"}}),_c('path',{attrs:{"d":"M24.375 1.5a4.125 4.125 0 11-4.125 4.125A4.13 4.13 0 0124.375 1.5zm0 6.25a2.125 2.125 0 10-2.125-2.125 2.127 2.127 0 002.125 2.125zM20.007 14.75h-.011a1 1 0 010-2h.011a1 1 0 110 2zM15.006 14.75h-.011a1 1 0 010-2h.011a1 1 0 110 2zM10.005 14.75h-.011a1 1 0 010-2h.011a1 1 0 110 2z","fill":"#bac1cc","opacity":".4"}})])
          )
        }
      }
    